import * as StyledComponents from '../UnifyAdministration/Notification/StyledComponents';
import { INPUT_SIZES, IconAdd } from 'cdk-radial';
import { useUnifyAdminStore } from '../UnifyAdministration/AdminStore';
import { SIDE_SHEET_TITLE_NAMES } from '../UnifyAdministration/Constants';
import { Switch } from 'cdk-radial';
import { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export default function LinkNotificationListHeader(
  props: Readonly<{ gridRef: React.RefObject<any> }>
): JSX.Element {
  const searchValue = useUnifyAdminStore((state) => state.linkSearchValue);
  const archiveSwitch = useUnifyAdminStore((state) => state.linkArchiveSwitch);
  const { t } = useTranslation();

  const setLinkSearchValue = useUnifyAdminStore(
    (state) => state.setLinkSearchValue
  );
  const setArchiveSwitch = useUnifyAdminStore(
    (state) => state.setLinkArchiveSwitch
  );
  const setSideSheetTitleName = useUnifyAdminStore(
    (state) => state.setSideSheetTitleName
  );
  const setLinkSheetCollapse = useUnifyAdminStore(
    (state) => state.setLinkSideSheetCollapse
  );
  const resetLinkSideSheetState = useUnifyAdminStore(
    (state) => state.resetLinkSideSheetState
  );

  useEffect(() => {
    setLinkSheetCollapse(true);
  }, [archiveSwitch, setLinkSheetCollapse]);

  const handleNewLink = (): void => {
    setSideSheetTitleName(SIDE_SHEET_TITLE_NAMES.APP_LINK);
    resetLinkSideSheetState();
    setLinkSheetCollapse(false);
  };

  const onArchiveChange = useCallback(
    (event: any) => {
      const checked = !!event?.target?.checked;
      setArchiveSwitch(checked);
      setLinkSearchValue('');
      const gridRef = props?.gridRef;
      try {
        if (gridRef && gridRef.current && (gridRef.current as any).api) {
          (gridRef.current as any).api.setQuickFilter('');
        }
      } catch (err) {
      }
    },
    [props, setArchiveSwitch, setLinkSearchValue]
  );

  return (
    <>
      <StyledComponents.StyledHeaderContainer>
        <div style={{display:'flex'}}>
        <StyledComponents.StyledHeading
          headingType="subtitle-2"
          data-testid="link-notification-list"
        >
          {t('linksAdmin.title')}
        </StyledComponents.StyledHeading>
        <StyledComponents.StyledSwitch>
          <Switch
                dataTestId="switch"
                id="archive"
                label={t('linksAdmin.showArchived')}
                labelPosition="before"
                name="archive"
                onChange={onArchiveChange}
                size="standard"
                checked={archiveSwitch}
              />
          </StyledComponents.StyledSwitch>
        </div>
      </StyledComponents.StyledHeaderContainer>

      <StyledComponents.StyledSearchBoxContainer>
        <StyledComponents.StyledSearchBox
          dataTestId="link-search-input"
          className="customize-search-input"
          clearButtonLabel="clearButtonLabel"
          id="link-grid-search-input-expanded"
          isAlwaysExpanded
          name="link-grid-search-input-expanded"
          onChange={(searchValue: string) => setLinkSearchValue(searchValue)}
          placeholder={t('linksAdmin.search')}
          size={INPUT_SIZES.STANDARD}
          value={searchValue}
        />
        {!archiveSwitch && (
          <StyledComponents.StyledButtonWithIcon
            onClick={() => handleNewLink()}
            variant="secondary"
            text={t('linksAdmin.createLink')}
            icon={<IconAdd />}
          />
        )}
      </StyledComponents.StyledSearchBoxContainer>
    </>
  );
}